import {
  ItemAttributeOption,
  NumericAspect,
} from "@/models/HomePageSearchResponse";
import _ from "lodash";

const AGE_OPTION_VALUES = [..._.range(1, 20), 25];

const AGE_OPTIONS: NumericAspect[] = AGE_OPTION_VALUES.map((value) => ({
  value,
  label: `${value} yr`,
}));

export default AGE_OPTIONS;

export const AGE_ATTRIBUTE_OPTIONS: ItemAttributeOption[] = _.range(0, 60).map(
  (value) => ({
    value: value.toString(),
    label: `${value} yr`,
  })
);
